angular.module("app").controller("PopupsListPageController", [
    '$scope',
    '$timeout',
    '$state',
    '$cookies',
    '$uibModal',
    '$window',
    '$templateRequest',
    '$interpolate',
    'pageStatuses',
    'preloadedPopupsList',
    'popupsService',
    'errorHandler',
    'logger',
    'pagination',
    'settingsService',
    'toolsMap',
    'popupTypes',
    'userStorage',
    function ($scope, $timeout, $state, $cookies, $modal, $window, $templateRequest, $interpolate,   pageStatuses, preloadedPopupsList, popupsService, errorHandler, logger, pagination, settingsService, toolsMap, popupTypes, userStorage) {

        var pendingListRequest,
            settings = settingsService.getSettings();
        $scope.languages = settings.skin.languages;
        $scope.pageStatuses = angular.copy(pageStatuses);
        $scope.pageStatuses.push("expired");
        $scope.popupTypes = angular.copy(popupTypes);
        $scope.popups = angular.copy(preloadedPopupsList.popups || []);
        $scope.items = angular.copy(preloadedPopupsList.popups) || {};
        $scope.allowUpdateContainer = {};
        $scope.pagination = pagination.init(function () {
             !!pendingListRequest && $timeout.cancel(pendingListRequest);
             pendingListRequest = $timeout(function () {
                  $scope.updateList()
             }, 300);
        }, parseInt(preloadedPopupsList.total_count), 25);
        $scope.filterOptions = {
            status: pageStatuses[0],
            language: $cookies.get("preferedLanguage") || settings.skin.defaultLang,
            is_mobile: popupTypes[0]
        };
        var initialOrders = getValuesByKey($scope.items, 'order');
        $scope.ignoreColumns = {
            'content': true,
            'country': true,
            'created_at': true,
            'custom_repeat': true,
            'end_date': true,
            'id': true,
            'image': true,
            'is_mobile': true,
            'lang': true,
            'link': true,
            'login': true,
            'new_window': true,
            'author': true,
            'order': true,
            'parent_id': true,
            'repeat_type': true,
            'skin_id': true,
            'start_date': true,
            'status': true
        };


        $scope.updateList = function () {
            var requestObject = {
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                is_mobile: $scope.filterOptions.is_mobile,
                current_page: $scope.pagination.page,
                lang: $scope.filterOptions.language || $cookies.get("preferedLanguage")
            };
            popupsService.getPopups(requestObject).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.popups = angular.copy(response.popups);
                        $scope.pagination.totalItems = parseInt(response.total_count);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

         /*
             *@ngdoc method
             *@name addMedia
             *@description When you want to open Media popup in Media View
          */
        $scope.editPopup = function (item) {
            $modal.open({
                templateUrl: "views/popups/edit.html",
                controller: "EditPopupPageController",
                resolve: {
                    preloadedPopupData: function () {
                        if (!item.id && item.id != 0) {
                            return {}
                        } else {
                            return popupsService.getPopupById({id: item.id}).then(
                                function (response) {
                                    if (response.status === "ok") {
                                        return angular.copy(response.popup)
                                    }
                                    errorHandler(response.message);
                                    return {}
                                },
                                function (response) {
                                    errorHandler(response.message)
                                }
                            )
                        }
                    },
                    preloadedNames: function () {
                        return popupsService.getActualNames({lang: $scope.filterOptions.language}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response)
                                }
                                errorHandler(response.message);
                                return {}

                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedTypes: function () {
                        return popupsService.getRepeatTypes().then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.repeat_types)
                                }
                                errorHandler(response.message);
                                return []

                            },
                            function (response) {
                                errorHandler(response.message);
                                return []
                            }
                        )
                    },
                    countryCodes: function(resourcesService) {
                        return resourcesService.getResource("countryCodes.json").then(
                            function (data) {
                                return angular.copy(data.data);
                        });
                    }
                }
            }).result.then(function () {
                $scope.updateList()
            });
        };

        /*
        *@ngdoc method
        *@name addPopup
        *@description When you want to add Popup in popups view
        */

        $scope.addPopup = function () {
            $modal.open({
                templateUrl: "views/popups/add.html",
                controller: "AddPopupPageController",
                resolve: {
                    preloadedNames: function () {
                        return popupsService.getActualNames({lang: $scope.filterOptions.language}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response)
                                }
                                errorHandler(response.message);
                                return {}
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedTypes: function () {
                        return popupsService.getRepeatTypes().then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.repeat_types)
                                }
                                errorHandler(response.message);
                                return []

                            },
                            function (response) {
                                errorHandler(response.message);
                                return []
                            }
                        )
                    },
                    countryCodes: function(resourcesService) {
                        return resourcesService.getResource("countryCodes.json").then(function (data) {
                            return angular.copy(data);
                        });
                    },
                    status: function () {
                        return $scope.filterOptions.status;
                    },
                    lang: function () {
                        return $scope.filterOptions.language;
                    }
                }
            }).result.then(function () {
                $scope.updateList()
            });
        };

        $scope.allowUpdateContainer.allowUpdate = function (options) {
            if (options && options.autoUpdate) {
                reorder();
            } else if (!!options) {
                $scope.tabOptions.reordered = true;
            }
        };

        function reorder () {
            if (typeof $scope.items === "object" && $scope.items.length) {
                reorderByService({
                    ids: getValuesByKey($scope.popups, 'id'),
                    orders: initialOrders
                }, popupsService);
            }
        }
        
        function reorderByService (orderData, service) {
            service.changeOrder({
                orderData: orderData
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        /*
        *@ngdoc method
        *@name toolsAction
        *@description When you want to make the table item inactive
        */

        $scope.toolsAction = function (page, action, title) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                controller: "ConfirmDeleteActionModalController"
            });
            modalInstance.result.then(function () {
                popupsService.toggleItemInactive(page.id, title).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.successfullyToggled" + title);
                            $scope.updateList()
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                )

            });
        };

        /*
        *@ngdoc method
        *@name deletePopup
        *@description When you want to delete Popup in popups list
        */
        $scope.deletePopup = function (popup) {
            var requestData = {
                id: popup.id
            };
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmDeleteAction.html",
                controller: "ConfirmDeleteActionModalController"
            });

            modalInstance.result.then(function () {
                    popupsService.deletePopupById(requestData).then(
                        function (response) {
                            if (response.status === "ok") {
                                $scope.updateList();
                                logger.logSuccess("Popup has been successfully archived");
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    )
                }
            );

        };

        $scope.publishPopup = function (popup) {

            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmPublishAction.html",
                controller: "ConfirmDeleteActionModalController"
            });

            var requestData = {
                popup: {
                    id: popup.id,
                    status: "published"
                }
            };

            modalInstance.result.then(function() {
                popupsService.update(requestData).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.updateList();
                            logger.logSuccess("Popup has been successfully published");
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            });


        };


        if (userStorage.getUserData().permissions.indexOf('managePopups') !== -1) {
            $scope.tools = {
                preview: {
                    action: function (item) {
                        $scope.onPreviewPopup(item);
                    },
                    title: function () {
                        return $scope.filterOptions.status ?  toolsMap[$scope.filterOptions.status].previewToggle.title : 'edit';
                    }
                },
                edit: {
                    action: function (item) {
                        $scope.editPopup(item);
                    },
                    title: function () {
                        return $scope.filterOptions.status ?  toolsMap[$scope.filterOptions.status].editToggle.title : 'edit';
                    }

                },
                inactiveToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                    }
                },
                publishToggle: {
                    action: function (item) {
                        $scope.filterOptions.status !== 'archive'  ? $scope.deletePopup(item) :  $scope.publishPopup(item)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.title;
                    }
                }
            };
        } else {
            $scope.tools = {
                preview: {
                    action: function (item) {
                        $scope.onPreviewPopup(item);
                    },
                    title: function () {
                        return $scope.filterOptions.status ? toolsMap[$scope.filterOptions.status].previewToggle.title : 'edit';
                    }
                }
            };
        }


        $scope.listFilterObject = {
            action: function (){
                $scope.updateList();
            }
        };

        /*
          *@ngdoc method
          *@name onPreviewPopup
          *@description When you want to make the table item preview
       */

        $scope.onPreviewPopup = function (item) {
            $scope.pageData = {
                title:  item.title,
                content: item.content
            };
            var myWindow = $window.open("", "MsgWindow", "width=1000,height=800");
            $templateRequest('views/templates/dialog/globaldialog.html').then(
                function (html) {
                    html = $interpolate(html)($scope);
                    var head = myWindow.document.head || myWindow.document.getElementsByTagName('head')[0];
                    myWindow.document.write(html);
                }
            );
        };
    }
]);
